/* eslint react/no-multi-comp: 0 */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import Lazy from '../common/lazy';
import ContentCaption from './content_caption';
import SocialIcons from '../common/social_icons';
import ResponsiveImg from '../common/responsive_img';
import {isEmpty, reduce} from 'lodash';
import { link_target, link_rel } from '../../utils/external_links';

export default function MultiImageSection(props) {
  const { content, url_full, sanitizedTitle, enableAdTextForShares, excerpt_truncated_325, meta_description, meta_title, social_title } = props;
  const images = content.images;
  const imageProps = {
    url_full, sanitizedTitle, enableAdTextForShares,
    excerpt_truncated_325, meta_description,
    meta_title, social_title
  };

  return (
    <div className={classNames('section-multi-image-container', images.length === 3 && 'section-multi-image-container-triptych')}>
      {
        images.map((image, index) => <MultiImageElement {...imageProps} key={index} image={image} />)
      }
    </div>
  );
}

MultiImageSection.propTypes = {
  sanitizedTitle: PropTypes.string.isRequired,
  enableAdTextForShares: PropTypes.bool,
  url_full: PropTypes.string.isRequired,
  excerpt_truncated_325: PropTypes.string.isRequired,
  content: PropTypes.shape({
    images: PropTypes.arrayOf(PropTypes.object).isRequired
  }),
  meta_description: PropTypes.string,
  meta_title: PropTypes.string,
  social_title: PropTypes.string
};

export class MultiImageElement extends PureComponent {
  state = { isLoaded: false };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (this.props.image.src !== nextProps.image.src) {
      this.setState({ isLoaded: false });
    }
  }

  handleImgLoad = () =>
    this.setState({ isLoaded: true });

  loadingClassNames = () =>
    classNames({ loading: !this.state.isLoaded });

  socialIcons = () => {
    const {
      url_full, sanitizedTitle, enableAdTextForShares,
      excerpt_truncated_325, meta_description,
      meta_title, social_title, image
    } = this.props;

    const socialIconProps = {
      url_full, asset_main: { src_full: image.src }, sanitizedTitle,
      enableAdTextForShares, excerpt_truncated_325, meta_description,
      meta_title, social_title
    };
    const icons = getIconsArray(image.is_pinnable, image.is_facebook_shareable);

    return (
      <SocialIcons {...socialIconProps}
        className="image-shares"
        icons={icons}
      />
    );
  }

  lazyWrappedImg = () => {
    const { image } = this.props;
    const img = (
      <ResponsiveImg
        src={image.src}
        alt={image.alt_title}
        className={this.loadingClassNames()}
        onLoad={this.handleImgLoad}
        {...image.dimensions}
      />
    );
    const wrappedImg = isEmpty(image.clicktracker)
      ? img
      : <a href={image.clicktracker} target={link_target(image.clicktracker)} rel={link_rel(image.clicktracker)}>{img}</a>;

    return (
      <Lazy cushion={null} className={this.loadingClassNames()} >
        {wrappedImg}
      </Lazy>
    );
  }

  render() {
    const { image } = this.props;

    return (
      <div>
        {this.lazyWrappedImg()}
        {this.socialIcons()}
        <ContentCaption credit={image.credit} description={image.description} />
      </div>
    );
  }
}

MultiImageElement.propTypes = {
  sanitizedTitle: PropTypes.string.isRequired,
  enableAdTextForShares: PropTypes.bool,
  url_full: PropTypes.string.isRequired,
  excerpt_truncated_325: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    credit: PropTypes.string,
    alt_title: PropTypes.string,
    description: PropTypes.string,
    is_pinnable: PropTypes.bool.isRequired,
    is_facebook_shareable: PropTypes.bool.isRequired,
    dimensions: PropTypes.shape({
      original_height_px: PropTypes.number.isRequired,
      original_width_px: PropTypes.number.isRequired
    }).isRequired,
    clicktracker: PropTypes.string
  }).isRequired,
  meta_description: PropTypes.string,
  meta_title: PropTypes.string,
  social_title: PropTypes.string
};

function getIconsArray(is_pinnable, is_facebook_shareable) {
  const iconsDict = {
    pinterest: is_pinnable,
    facebook: is_facebook_shareable
  };
  return reduce(iconsDict, (icons, shouldRenderIcon, icon) =>
    shouldRenderIcon ? [...icons, icon] : icons,
  []);
}